interface ShouldAdoptServerContentArgs {
  didPathChange: boolean;
  draftsInvalidated: boolean;
  hasLocalDraft: boolean;
}

interface ResolveEditorContentArgs {
  draftContent?: string;
  fileContent?: string;
  tombstoneContent?: string;
}

interface ShouldClearLocalDraftOnServerAdvanceArgs {
  draftContent?: string;
  previousServerContent?: string;
  nextServerContent?: string;
}

/**
 * During active typing, local draft state is the source of truth.
 * We only re-seed editor content from server data on explicit boundaries.
 */
export function shouldAdoptServerContent({
  didPathChange,
  draftsInvalidated,
  hasLocalDraft,
}: ShouldAdoptServerContentArgs): boolean {
  if (didPathChange) return true;
  if (draftsInvalidated) return true;
  return !hasLocalDraft;
}

/**
 * If the "local draft" is just an echo of the previously-seen server content,
 * and the server advances (e.g. agent edit, sync, collaborator), we can safely
 * drop the draft and adopt the new server content without clobbering user input.
 */
export function shouldClearLocalDraftOnServerAdvance({
  draftContent,
  previousServerContent,
  nextServerContent,
}: ShouldClearLocalDraftOnServerAdvanceArgs): boolean {
  if (draftContent === undefined) return false;
  if (previousServerContent === undefined) return false;
  if (nextServerContent === undefined) return false;
  if (nextServerContent === previousServerContent) return false;
  return draftContent === previousServerContent;
}

export function resolveEditorContent({
  draftContent,
  fileContent,
  tombstoneContent,
}: ResolveEditorContentArgs): string {
  if (draftContent !== undefined) return draftContent;
  if (fileContent !== undefined) return fileContent;
  if (tombstoneContent !== undefined) return tombstoneContent;
  return "";
}
